/// <reference path="DataReader.ts" />

namespace ui
{
	export namespace table
	{

		export abstract class DataModel<T>
		{
			protected m_DataReader: ui.table.DataReader<any>|undefined;

			public present( root: JQuery<HTMLElement> ): void
			{
				root.empty();

				root.append( this.buildContent() );
			}

			public ModelReader(): ui.table.DataReader<T>;
			public ModelReader( reader: ui.table.DataReader<T> ): void;
			public ModelReader( reader?: ui.table.DataReader<T> ): ui.table.DataReader<T>|void
			{
				if ( reader )
				{
					this.m_DataReader = reader;

					return;
				}

				return this.m_DataReader;
			}

			public buildContent(): JQuery
			{
				if ( this.m_DataReader )
				{
					return this.build();
				}

				return ui.$$.pre().text( 'NO_MODEL_READER_ATTACHED' );
			}

			protected constructor(){}

			protected abstract build(): JQuery<HTMLElement>;

		}
	}
}
